import { render, staticRenderFns } from "./TranslatedContent.vue?vue&type=template&id=82381ac6"
import script from "./TranslatedContent.vue?vue&type=script&lang=js"
export * from "./TranslatedContent.vue?vue&type=script&lang=js"
import style0 from "./TranslatedContent.vue?vue&type=style&index=0&id=82381ac6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports